import { getRequest, postRequest, patchRequest, deleteRequest } from '../utils/axios';
import { buildUrlParams } from '../utils/urls';

export const brandsService = {
  listBrands: (onSuccess, onError, params = {}) => {
    const url = '/api/v1/brands/' + buildUrlParams(params);
    getRequest(
      url,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  getBrand: (hash, onSuccess, onError) => {
    getRequest(
      `/api/v1/brands/${hash}/`,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  createBrand: (data, onSuccess, onError) => {
    postRequest(
      '/api/v1/brands/',
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  validateInputs: (data, onSuccess, onError) => {
    postRequest(
      '/api/v1/brands/validate/',
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  addCreator: (hash, data, onSuccess, onError) => {
    postRequest(
      `/api/v1/brands/${hash}/add-creator/`,
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  removeCreator: (hash, data, onSuccess, onError) => {
    postRequest(
      `/api/v1/brands/${hash}/remove-creator/`,
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  getPopulationStatus: (hash, onSuccess, onError, params = {}) => {
    const urlParams = buildUrlParams(params);
    const url = `/api/v1/brands/${hash}/population-status/${urlParams}`;
    getRequest(
      url,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  syncBrand: (hash, onSuccess, onError, body = {}) => {
    postRequest(
      `/api/v1/brands/${hash}/sync/`,
      body,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  updateBrand: (hash, data, onSuccess, onError) => {
    patchRequest(
      `/api/v1/brands/${hash}/`,
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  deleteBrand: (hash, onSuccess, onError) => {
    deleteRequest(
      `/api/v1/brands/${hash}/`,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  listIdeas: (params, onSuccess, onError) => {
    const url = '/api/v1/ideas/' + buildUrlParams(params);
    getRequest(
      url,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  createIdeas: (data, onSuccess, onError) => {
    postRequest(
      '/api/v1/ideas/generate/',
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  updateIdea: (hash, data, onSuccess, onError) => {
    patchRequest(
      `/api/v1/ideas/${hash}/`,
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  getIdea: (hash, onSuccess, onError) => {
    getRequest(
      `/api/v1/ideas/${hash}/`,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  createIdeaRun: (data, onSuccess, onError) => {
    postRequest(
      '/api/v1/idea-runs/',
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  getLatestIdeaRun: (brandHash, onSuccess, onError) => {
    getRequest(
      `/api/v1/idea-runs/latest/?brand_hash=${encodeURIComponent(brandHash)}`,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  getIdeaRun: (hash, onSuccess, onError) => {
    getRequest(
      `/api/v1/idea-runs/${hash}/`,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  getIdeaRunPopulationStatus: (hash, onSuccess, onError) => {
    getRequest(
      `/api/v1/idea-runs/${hash}/population-status/`,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  listScripts: (params, onSuccess, onError) => {
    const url = '/api/v1/scripts/' + buildUrlParams(params);
    getRequest(
      url,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  createScript: (data, onSuccess, onError) => {
    postRequest(
      '/api/v1/scripts/',
      data,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  getScript: (hash, onSuccess, onError) => {
    getRequest(
      `/api/v1/scripts/${hash}/`,
      (response) => onSuccess?.(response),
      (error, response) => onError?.(error, response)
    );
  },

  generateSceneVisual: (scriptHash, sceneNumber, options = {}, onSuccess, onError) => {
    const body = { scene_number: sceneNumber };
    if (options.regenerate) {
      body.regenerate = true;
    }
    if (options.prompt) {
      body.prompt = options.prompt;
    }
    postRequest(
      `/api/v1/scripts/${scriptHash}/generate-scene-visual/`,
      body,
      (response) => onSuccess?.(response.data),
      (error, response) => onError?.(error, response)
    );
  },
};
